import { useEffect, useState } from 'react';
import { IconType } from 'react-icons';
import { useNavigate, useParams } from 'react-router';
import { ITabsMapper } from 'types';
import { indexOfObject } from 'utils/arrays';

const tabsMapper: ITabsMapper = {
    '/home': {
        id: 102,
    },
    '/': {
        id: 102,
    },
    '': {
        id: 102,
    },
    '/keywords-management/keywords': {
        id: 96,
    },
    '/user-management/users': {
        id: 98,
    },
    '/user-management/company-group': {
        id: 98,
    },
    '/user-management/international-company-groups': {
        id: 17,
    },
    '/pictures-management': {
        id: 99,
    },
    '/sectorisation/datafield': {
        id: 123,
    },
    '/sectorisation/dashboard': {
        id: 123,
    },
    '/shop-cluster': {
        id: 0,
    },
    '/product-management': {
        id: 97,
    },
    '/product-management/pdp': {
        id: 182,
    },
    '/product-management/splits': {
        id: 109,
    },
    '/list-management/dashboard': {
        id: 112,
    },
    '/list-management/datafield': {
        id: 112,
    },
    '/product-search-score': {
        id: 113,
    },
    '/preferences/colors': {
        id: 138,
    },

    '/history': {
        id: 102,
    },
};

export type TSubRoute = { path: string; icon?: IconType; hide?: boolean };
type TSubRoutes = Record<string, TSubRoute[]>;

export const subRoutes: TSubRoutes = {
    sectorisation: [
        { path: 'datafield', icon: undefined, hide: true },
        { path: 'dashboard', icon: undefined, hide: true },
    ],
    'cluster-management': [
        { path: 'shop-cluster', icon: undefined },
        { path: 'cluster', icon: undefined },
        { path: 'product-cluster', icon: undefined },
    ],
    'list-management': [
        { path: 'dashboard', icon: undefined, hide: true },
        { path: 'datafield', icon: undefined, hide: true },
    ],
    'keywords-management': [
        { path: 'keywords', icon: undefined },
        { path: 'ean-keywords', icon: undefined },
        { path: 'keywords-categories', icon: undefined },
        { path: 'keywords-by-retailers', icon: undefined },
    ],
    'product-management': [
        { path: '', icon: undefined },
        { path: 'pdp', icon: undefined },
        { path: 'splits', icon: undefined },
        { path: 'aliases', icon: undefined },
        { path: 'facultative', icon: undefined },
    ],
    'user-management': [
        { path: 'users', icon: undefined },
        { path: 'company-group', icon: undefined },
        { path: 'international-company-groups', icon: undefined },
    ],
    preferences: [
        {
            path: 'colors',
            icon: undefined,
        },
        {
            path: 'global-categories',
            icon: undefined,
        },
    ],
};

export const useTabNavigate = (keyUrl: string, rules?: any) => {
    const navigate = useNavigate();
    const { page } = useParams();

    // The parameter "rules" contains the rules to show or hide tabs.
    // Example of rules: { 'keywords-categories': false } when the tab should be hidden.
    const tab = rules ? subRoutes[keyUrl].filter((r) => rules[r.path] !== false) : subRoutes[keyUrl];
    const requestedTabIndex = page ? indexOfObject(tab, (t) => t.path === page) : 0;
    const tabIdx = requestedTabIndex >= 0 ? requestedTabIndex : 0;

    const [tabIndex, setTabIndex] = useState(tabIdx);
    const selectedPath = tab[tabIndex]?.path || tab[0]?.path;

    useEffect(() => {
        if (selectedPath) {
            navigate(`/${keyUrl}/${selectedPath}`, { replace: true });
        }
    }, [keyUrl, navigate, selectedPath]);

    useEffect(() => {
        setTabIndex(tabIdx);
    }, [tabIdx]);

    return { tabIndex, setTabIndex };
};

export default tabsMapper;
